import { Box, Button, FieldSwitch, Page, Table } from '@dixa/lib-shared-habla';
import { ChangeEvent } from 'react';

import { integrationsApi } from 'apis/integrations';
import { appActions } from 'app/app.actions';
import { useAppDispatch } from 'utils/redux/useAppDispatch';

import { DomainRecordsTable } from './components/domainRecordsTable/domainRecordsTable';
import { EmailDomainModal } from './components/emailDomainModal/emailDomainModal';

export const SettingsEmailDomainsTableView = (): JSX.Element => {
  const dispatch = useAppDispatch();

  const { domains, isLoading } = integrationsApi.useReadEmailDomainsQuery(
    undefined,
    {
      selectFromResult: ({ data, ...rest }) => ({
        ...rest,
        domains: data?.data.email_identities ?? [],
      }),
    },
  );

  const [updatePixelTracking] =
    integrationsApi.useUpdatePixelTrackingStatusMutation();

  const handlePixelTracking = async (enabled: boolean, identityId: string) => {
    await updatePixelTracking({ identityId, enabled });
  };

  const handleAddDomain = () => {
    dispatch(
      appActions.showModal({
        modal: { type: 'settings:addEmailDomain', arg: {} },
      }),
    );
  };

  return (
    <>
      <Page.Section
        title="Email domains"
        controls={<Button onClick={handleAddDomain}>Add domain</Button>}
      >
        <Table
          expandableRowsProps={{
            expandableRows: true,
          }}
          stickyHeader
          loadingStrategy="spinner"
          loading={isLoading}
          emptyState={
            !isLoading && domains.length === 0
              ? {
                  title: 'Nothing to show',
                  description: 'No email domains found',
                }
              : undefined
          }
        >
          <Table.Thead>
            <Table.Tr>
              <Table.Th width="55%">Domain</Table.Th>
              <Table.Th width="30%">Status</Table.Th>
              <Table.Th width="15%">Tracking pixel</Table.Th>
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>
            {domains.map((emailDomain, index) => (
              <Table.Tr
                key={emailDomain.identity + emailDomain.organization_id}
                rowId={`row-${index}`}
                expandableContent={
                  <DomainRecordsTable emailDomain={emailDomain} />
                }
              >
                <Table.Td>{emailDomain.identity}</Table.Td>
                <Table.Td>
                  <Box
                    width="8px"
                    height="8px"
                    borderRadius="50%"
                    background={
                      emailDomain.is_verified ? 'green.500' : 'red.500'
                    }
                  />
                </Table.Td>
                <Table.Td>
                  <FieldSwitch
                    input={{
                      name: `switch-${index}`,
                      checked: emailDomain.delivery_tracking?.tracking_enabled,
                      value: 'false',
                      disabled: !(
                        emailDomain.delivery_tracking?.tracking_enabled &&
                        (emailDomain.delivery_tracking
                          ?.cname_dns_record_published ??
                          true)
                      ),
                      onChange: (event: ChangeEvent<HTMLInputElement>) =>
                        handlePixelTracking(
                          event.target.checked,
                          emailDomain.identity,
                        ),
                    }}
                  />
                </Table.Td>
              </Table.Tr>
            ))}
          </Table.Tbody>
        </Table>
      </Page.Section>
      <EmailDomainModal />
    </>
  );
};
